export function setAnalyticsFromGroupcall(digitalData) {
  return {
    type: 'FILL_DIGITAL_DATA',
    digitalData: digitalData
  };
}
